import CvSectionTemplate from './CvSectionTemplate';

export default function CvLinks() {
  return (
    <CvSectionTemplate
      currentId="check_4"
      description="Podaj odnośniki do swojego portfolio, LinkedIn, GitHuba lub innych stron zawodowych."
    />
  );
}
